// Angular imports
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
// Rxjs imports
import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/cdk/layout";
export class ScreenConstants {
}
ScreenConstants.home = {};
ScreenConstants.headerSm = {
    logoLocation: 'center',
    menuButtonWidth: '60px'
};
ScreenConstants.header = {
    logoLocation: 'before',
    menuButtonWidth: '230px'
};
ScreenConstants.userPanel = {
    menuButtonWidth: '170px'
};
ScreenConstants.searchPanelSm = {
    menuSearchWidth: '300px'
};
ScreenConstants.searchPanelMd = {
    menuSearchWidth: '400px'
};
ScreenConstants.searchPanel = {
    menuSearchWidth: '800px'
};
ScreenConstants.help = {
    toolBarHeight: '60',
    menuDropDownWidth: '170px',
    menuCiraAppWidth: '230px',
    drawerOpenMode: true
};
ScreenConstants.helpSm = Object.assign({}, ScreenConstants.help, {
    drawerOpenMode: false
});
ScreenConstants.contextTree = {
    treeWidth: '350',
    searchPanelWidth: '340'
};
ScreenConstants.contentTree = {
    treeWidth: '350',
    searchPanelWidth: '340'
};
ScreenConstants.content = {
    maxWidthEmailHelpPopup: '100%',
    maxHeightEmailHelpPopup: '100%',
    maxWidthHelpURLPopup: '100%',
    maxHeightHelpURLPopup: '100%',
    maxWidthPrintPreviewPopup: '100%',
    maxHeightPrintPreviewPopup: '100%'
};
ScreenConstants.contentLg = {
    maxWidthEmailHelpPopup: '500px',
    maxHeightEmailHelpPopup: '250px',
    maxWidthHelpURLPopup: '500px',
    maxHeightHelpURLPopup: '230px',
    maxWidthPrintPreviewPopup: '700px',
    maxHeightPrintPreviewPopup: '800px'
};
export class ScreenService {
    constructor(breakpointObserver) {
        this.breakpointObserver = breakpointObserver;
        this.changed = new Subject();
        this.resized = new Subject();
        const TIMEOUT = 1000;
        let bpTimerId;
        this.breakpointObserver
            .observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large])
            .subscribe(() => {
            clearTimeout(bpTimerId);
            bpTimerId = setTimeout(() => {
                this.changed.next();
                clearTimeout(bpTimerId);
            }, TIMEOUT);
        });
        let sizeTimerId;
        window.addEventListener('resize', () => {
            clearTimeout(sizeTimerId);
            sizeTimerId = setTimeout(() => {
                this.resized.next();
                clearTimeout(sizeTimerId);
            }, TIMEOUT);
        });
    }
    get sizes() {
        return {
            'screen-x-small': this.breakpointObserver.isMatched(Breakpoints.XSmall),
            'screen-small': this.breakpointObserver.isMatched(Breakpoints.Small),
            'screen-medium': this.breakpointObserver.isMatched(Breakpoints.Medium),
            'screen-large': this.isLargeScreen()
        };
    }
    get getCurrentScreenSize() {
        if (this.breakpointObserver.isMatched(Breakpoints.XSmall)) {
            return 'screen-x-small';
        }
        else if (this.breakpointObserver.isMatched(Breakpoints.Small)) {
            return 'screen-small';
        }
        else if (this.breakpointObserver.isMatched(Breakpoints.Medium)) {
            return 'screen-medium';
        }
        else if (this.isLargeScreen()) {
            return 'screen-large';
        }
        // return large screen as default
        return 'lg';
    }
    isLargeScreen() {
        return (this.breakpointObserver.isMatched(Breakpoints.Large) ||
            this.breakpointObserver.isMatched(Breakpoints.XLarge));
    }
    isSmallScreen() {
        return (this.breakpointObserver.isMatched(Breakpoints.Small) ||
            this.breakpointObserver.isMatched(Breakpoints.XSmall));
    }
    isMediumScreen() {
        return this.breakpointObserver.isMatched(Breakpoints.Medium);
    }
    isXSmallScreen() {
        return this.breakpointObserver.isMatched(Breakpoints.XSmall);
    }
    hasMinHeight() {
        if (!!window.visualViewport) {
            return window.visualViewport.height >= 800;
        }
        return window.outerHeight >= 800;
    }
    getScreenParams(size) {
        const defaultParams = {
            header: ScreenConstants.header,
            userpanel: ScreenConstants.userPanel,
            searchpanel: ScreenConstants.searchPanel,
            help: ScreenConstants.help,
            home: ScreenConstants.home,
            contextTree: ScreenConstants.contextTree,
            contentTree: ScreenConstants.contentTree,
            content: ScreenConstants.content
        };
        if (size.length > 1) {
            switch (size) {
                case 'screen-x-small':
                case 'screen-small': {
                    return Object.assign({}, defaultParams, {
                        header: ScreenConstants.headerSm,
                        searchpanel: ScreenConstants.searchPanelSm,
                        help: ScreenConstants.helpSm
                    });
                }
                case 'screen-medium': {
                    return Object.assign({}, defaultParams, {
                        searchpanel: ScreenConstants.searchPanelMd
                    });
                }
                case 'screen-large': {
                    return Object.assign({}, defaultParams, {
                        content: ScreenConstants.contentLg
                    });
                }
            }
        }
        // Return large screen view by default
        return Object.assign({}, defaultParams, {
            content: ScreenConstants.contentLg
        });
    }
}
ScreenService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ScreenService_Factory() { return new ScreenService(i0.ɵɵinject(i1.BreakpointObserver)); }, token: ScreenService, providedIn: "root" });
